import React, { useRef, useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import styles from './styles.module.scss';

export const DescriptionBox = ({ t, data, lang }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);

  useEffect(() => {
    const checkHeight = () => {
      if (contentRef.current) {
        setShowReadMore(contentRef.current.scrollHeight > 319);
      }
    };
    checkHeight();
  }, [data, lang]);

  return (
    <Box>
      <Box
        sx={{
          position: 'relative',
          maxHeight: expanded ? 'none' : 319,
          overflow: expanded ? 'visible' : 'hidden',
          transition: 'max-height 0.3s',
        }}
      >
        <div
          ref={contentRef}
          className={styles.richContent}
          dangerouslySetInnerHTML={{
            __html: data[`project_Information_${lang}`]?.replace(/(?:\r\n|\r|\n)/g, '<br/>') || '',
          }}
        />
        {!expanded && showReadMore && (
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              right: 0,
              bottom: 0,
              height: 60,
              background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, #fff 80%)',
              pointerEvents: 'none',
            }}
          />
        )}
      </Box>

      <Box textAlign="center">
        {!expanded && showReadMore && (
          <Button
            variant="text"
            size="medium"
            onClick={() => setExpanded((v) => !v)}
            endIcon={<ControlPointIcon sx={{ color: (theme) => theme.palette.primary.main }} />}
            sx={{
              color: '#000',
              textTransform: 'none',
              '&:hover': {
                color: (theme) => theme.palette.primary.main,
                backgroundColor: 'transparent',
              },
            }}
          >
            {t('read-all')}
          </Button>
        )}
      </Box>
    </Box>
  );
};
